export type FinanceBankAccountRole = 'personal' | 'household' | 'self_employed_business';

export type FinanceBankAccountRoleOption = {
  value: FinanceBankAccountRole;
  label: string;
  shortLabel: string;
  description: string;
};

export const FINANCE_BANK_ACCOUNT_ROLE_OPTIONS: readonly FinanceBankAccountRoleOption[] = [
  {
    value: 'personal',
    label: 'Personal',
    shortLabel: 'Personal',
    description: 'Use this for your normal personal current or savings account.',
  },
  {
    value: 'household',
    label: 'Household shared',
    shortLabel: 'Household',
    description: 'Use this if the account is mainly for shared household money rather than just you.',
  },
  {
    value: 'self_employed_business',
    label: 'Self-employed business',
    shortLabel: 'Business',
    description: 'Use this when the account is mainly for self-employed income and business spending, so Adulting keeps it out of your personal money view.',
  },
] as const;

export function normaliseFinanceBankAccountRole(value: string | null | undefined): FinanceBankAccountRole {
  if (value === 'household' || value === 'self_employed_business') {
    return value;
  }

  return 'personal';
}

export function getFinanceBankAccountRoleLabel(value: string | null | undefined) {
  return FINANCE_BANK_ACCOUNT_ROLE_OPTIONS.find((option) => option.value === normaliseFinanceBankAccountRole(value))?.label || 'Personal';
}

export function isFinanceBankAccountBusiness(value: string | null | undefined) {
  return normaliseFinanceBankAccountRole(value) === 'self_employed_business';
}

export function shouldIncludeFinanceBankAccountInMoneyView(value: string | null | undefined) {
  return !isFinanceBankAccountBusiness(value);
}
